<template>
  <!-- 效果评估策略制定表单 -->
  <div>
    <el-form ref="applyForm" :model="addFrom" class="xgpg_audit_form">
      <div class="xgpg_audit_wrap">
        <el-row
          style="padding-bottom: 10px"
          v-if="
            (xgpg.applyData2.status == 1 || xgpg.applyData2.status == 4) &&
            xgpg.applyData2.isExecutor == 1
          "
        >
          <el-col style="display: flex; align-items: center; ">
            <el-upload
              action="#"
              class="upload-demo"
              ref="upload"
              :headers="headers"
              :on-change="handleChange"
              :on-exceed="handleExceed"
              :file-list="fileList"
              :auto-upload="false"
              multiple
              :limit="fileNum"
            >
              <el-button icon="el-icon-upload" size="small" plain
                >选择附件</el-button
              >
            </el-upload>

            <div style="margin-left: 15px; display: flex; flex-direction: column; align-items: flex-start;">
            <span style="color: red;">
              请上传一把手关注点的相关材料，如访谈纪要、讲话稿等
            </span>
            <span>
              支持上传PPTX、PPT、PDF、DOC、DOCX、ZIP、RAR，最多3个文件且单个文件大小不能超过20M
            </span>
          </div>
          
          <span style="cursor: pointer; margin-left: 15px;" @click="fileListShow = !fileListShow">
            <i :class="fileListShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </span>

          </el-col>
        </el-row>
        <el-row>
          <transition name="fade">
            <el-table
              v-show="fileListShow"
              :data="xgpg.applyData2.files"
              fit
              size="mini"
              border
              stripe
              :header-cell-style="tableHeaderColor"
              :default-sort="{ prop: 'date', order: 'descending' }"
              tooltip-effect="dark"
            >
              <el-table-column
                label="操作"
                prop="xmmc"
                min-width="100px"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span
                    @click="handleDownloadFile(scope.row)"
                    style="color: #036eb8; cursor: pointer"
                    >下载</span
                  >
                  <span
                    @click="handleViewFile(scope.row)"
                    style="color: #036eb8; margin: 0 15px; cursor: pointer"
                    >预览</span
                  >
                  <span
                    v-if="
                      (xgpg.applyData2.status == 1 ||
                        xgpg.applyData2.status == 4) &&
                      xgpg.applyData2.isExecutor == 1
                    "
                    @click="handleDeleteFile(scope.row)"
                    style="color: #d9001b; cursor: pointer"
                    >删除</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="文件名字"
                prop="fileName"
                min-width="200px"
                :show-overflow-tooltip="true"
                align="center"
              ></el-table-column>
              <el-table-column
                label="文件类型"
                prop="fileType"
                min-width="80px"
                :show-overflow-tooltip="true"
                align="center"
              ></el-table-column>
              <el-table-column
                label="文件大小"
                prop="fileSize"
                min-width="80px"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <div>
                    {{ (scope.row.fileSize / 1024 / 1024).toFixed(2) }}M
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="上传人"
                prop="uploader"
                min-width="80px"
                :show-overflow-tooltip="true"
                align="center"
              ></el-table-column>
              <el-table-column
                label="上传时间"
                prop="uploadTime"
                min-width="80px"
                :show-overflow-tooltip="true"
                align="center"
              ></el-table-column>
              <template slot="empty">
                <div class="nodata">
                  <img src="@/img/nodata.png" alt="" width="160" />
                  <div>暂无数据</div>
                </div>
              </template>
            </el-table>
          </transition>
        </el-row>
        <el-row style="padding-bottom: 10px; margin-top: 10px">
          <el-col :span="12">
            <el-form-item
              label="评估类型"
              style="position: relative; padding-left: 8px"
            >
              <span
                style="position: absolute; top: 3px; left: -8px; color: #f56c6c"
                >*</span
              >
              <el-tooltip
                class="item"
                effect="dark"
                content="根据评审通过的效果评估策略选择的评估类型进行自动填充，无须选择；如未显示内容，请先进行并完成效果评估策略制定工作。"
                placement="right"
              >
                <el-select
                  v-model="xgpg.applyData2.v6"
                  style="width: calc(100% - 100px)"
                >
                  <el-option
                    v-for="item in xgpg.pglxList"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  ></el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="linkTaskId">
              <el-select
                v-model="xgpg.applyData2.v6"
                style="width: 100%"
                disabled
              >
                <el-option
                  v-for="item in xgpg.pglxList"
                  :key="item.dictValue"
                  :label="item.remark"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="scroll_row">
          <div>
            <el-col :span="24">
              <div class="row_title">
                <div><span>*</span>1.评估主题</div>
                <div @click="handleShowHistory">过往评估主题</div>
              </div>
              <el-form-item :label="`咨询师(${xgpg.applyData2.xm})`">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评审标准：用一句话清晰表达价值、核心问题和策略"
                  v-model="xgpg.applyData2.v1"
                />
              </el-form-item>
              <el-form-item
                :label="`分公司(${xgpg.applyData2.fgsReview.xm})`"
                v-if="xgpg.applyData2.fgsReview.id"
              >
                <el-input
                  type="textarea"
                  disabled
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评审标准：用一句话清晰表达价值、核心问题和策略"
                  v-model="xgpg.applyData2.fgsReview.v1"
                />
              </el-form-item>
              <el-form-item
                :label="`咨询管理部(${xgpg.applyData2.zxbReview.xm})`"
                v-if="xgpg.applyData2.zxbReview.id"
              >
                <el-input
                  type="textarea"
                  disabled
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评审标准：用一句话清晰表达价值、核心问题和策略"
                  v-model="xgpg.applyData2.zxbReview.v1"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="row_title">
                <div><span>*</span>2.列明关键问题、痛点问题和原因</div>
              </div>
              <el-form-item :label="`咨询师(${xgpg.applyData2.xm})`">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评审标准：是否抓到关键问题和原因，对于年度评估、续约评估、专题评估是否深入挖掘痛点问题"
                  v-model="xgpg.applyData2.v2"
                />
              </el-form-item>
              <el-form-item
                :label="`分公司(${xgpg.applyData2.fgsReview.xm})`"
                v-if="xgpg.applyData2.fgsReview.id"
              >
                <el-input
                  type="textarea"
                  disabled
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评审标准：是否抓到关键问题和原因，对于年度评估、续约评估、专题评估是否深入挖掘痛点问题"
                  v-model="xgpg.applyData2.fgsReview.v2"
                />
              </el-form-item>
              <el-form-item
                :label="`咨询管理部(${xgpg.applyData2.zxbReview.xm})`"
                v-if="xgpg.applyData2.zxbReview.id"
              >
                <el-input
                  disabled
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评审标准：是否抓到关键问题和原因，对于年度评估、续约评估、专题评估是否深入挖掘痛点问题"
                  v-model="xgpg.applyData2.zxbReview.v2"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="row_title">
                <div><span>*</span>3.解决方案的亮点和价值</div>
              </div>
              <el-form-item :label="`咨询师(${xgpg.applyData2.xm})`">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评审标准：  (1)首次评估：是否有利于夯实绩效管理基
                  (2)半年评估：是否纠偏或强化了绩效管理，有利于价值目标实现
                  (3)年度评估、提升评估：是否能支撑明年目标的实现
                  (4)续约评估：规划是否按照续约表模板制定，内容是否有效解决痛点问题，是否有利于实现目
                  (5)一把手变更评估：是否充分体现天维工时不可替代的价值
                  (6)专题评估：方案是否能有效解决问题，并降低咨询风险"
                  v-model="xgpg.applyData2.v3"
                />
              </el-form-item>
              <el-form-item
                :label="`分公司(${xgpg.applyData2.fgsReview.xm})`"
                v-if="xgpg.applyData2.fgsReview.id"
              >
                <el-input
                  disabled
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评审标准：  (1)首次评估：是否有利于夯实绩效管理基础
                  (2)半年评估：是否纠偏或强化了绩效管理，有利于价值目标实现
                  (3)年度评估、提升评估：是否能支撑明年目标的实现
                  (4)续约评估：规划是否按照续约表模板制定，内容是否有效解决痛点问题，是否有利于实现目标
                  (5)一把手变更评估：是否充分体现天维工时不可替代的价值
                  (6)专题评估：方案是否能有效解决问题，并降低咨询风险"
                  v-model="xgpg.applyData2.fgsReview.v3"
                />
              </el-form-item>
              <el-form-item
                :label="`咨询管理部(${xgpg.applyData2.zxbReview.xm})`"
                v-if="xgpg.applyData2.zxbReview.id"
              >
                <el-input
                  disabled
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评审标准：  (1)首次评估：是否有利于夯实绩效管理基础
                  (2)半年评估：是否纠偏或强化了绩效管理，有利于价值目标实现
                  (3)年度评估、提升评估：是否能支撑明年目标的实现
                  (4)续约评估：规划是否按照续约表模板制定，内容是否有效解决痛点问题，是否有利于实现目标
                  (5)一把手变更评估：是否充分体现天维工时不可替代的价值
                  (6)专题评估：方案是否能有效解决问题，并降低咨询风险"
                  v-model="xgpg.applyData2.zxbReview.v3"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="row_title">
                <div><span>*</span>4.解决一把手关注点和如何支持其实现</div>
              </div>
              <el-form-item :label="`咨询师(${xgpg.applyData2.xm})`">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评审标准：是否符合一把手关注点，支持一把手观点落地"
                  v-model="xgpg.applyData2.v4"
                />
              </el-form-item>
              <el-form-item
                :label="`分公司(${xgpg.applyData2.fgsReview.xm})`"
                v-if="xgpg.applyData2.fgsReview.id"
              >
                <el-input
                  disabled
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评审标准：是否符合一把手关注点，支持一把手观点落地"
                  v-model="xgpg.applyData2.fgsReview.v4"
                />
              </el-form-item>
              <el-form-item
                :label="`咨询管理部(${xgpg.applyData2.zxbReview.xm})`"
                v-if="xgpg.applyData2.zxbReview.id"
              >
                <el-input
                  disabled
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评审标准：是否符合一把手关注点，支持一把手观点落地"
                  v-model="xgpg.applyData2.zxbReview.v4"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="row_title">
                <div><span>*</span>5.报告结构</div>
              </div>
              <el-form-item :label="`咨询师(${xgpg.applyData2.xm})`">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评审标准：框架是否符合或优于模板标准"
                  v-model="xgpg.applyData2.v5"
                />
              </el-form-item>
              <el-form-item
                :label="`分公司(${xgpg.applyData2.fgsReview.xm})`"
                v-if="xgpg.applyData2.fgsReview.id"
              >
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评审标准：框架是否符合或优于模板标准"
                  v-model="xgpg.applyData2.fgsReview.v5"
                  disabled
                />
              </el-form-item>
              <el-form-item
                :label="`咨询管理部(${xgpg.applyData2.zxbReview.xm})`"
                v-if="xgpg.applyData2.zxbReview.id"
              >
                <el-input
                  disabled
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评审标准：框架是否符合或优于模板标准"
                  v-model="xgpg.applyData2.zxbReview.v5"
                />
              </el-form-item>
            </el-col>
          </div>
        </el-row>
      </div>
    </el-form>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="this.title"
      :visible.sync="historyDialog"
      width="80%"
      v-if="historyDialog"
      append-to-body
      id="history-dialog"
    >
      <div v-if="historyList && historyList.length > 0">
        <div v-for="(item, index) in historyList" :key="index">
          <div class="history_row">
            <div>申请日期： {{ item.createtime }}</div>
            <div>申请人： {{ item.xm }}</div>
            <div>效果评估类型： {{ item.type }}</div>
          </div>
          <div>
            <el-input
              type="textarea"
              :autosize="{ minRows: 6, maxRows: 6 }"
              placeholder="请输入备注"
              disabled
              v-model="item.nr"
            />
          </div>
        </div>
      </div>
      <div
        v-else
        style="
          text-align: center;
          font-size: 16px;
          font-weight: 700;
          color: #999;
        "
      >
        <img src="@/img/nodata.png" alt="" width="240" />
        <div>暂无数据</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="historyDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getDict } from "@/api/common.js";
import {
  delFileInfo,
  getLinkTask,
  getZxpsGw,
  saveZxpsApply,
  submitZxpsApply,
  uploadFile,
} from "@/api/xgpg.js";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { Loading } from "element-ui";

export default {
  name: "apply",
  computed: {
    ...mapGetters(["deptUser", "xgpg"]),
  },
  components: { Treeselect },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      fileList: [],
      historyDialog: false,
      adviceDialog: false,
      addFrom: {
        advice: null,
      },
      evaluation: "3",
      checkbox5: 1,
      pglxList: [],
      linkList: [],
      status: null,
      parentDialog: false,
      historyList: [],
      title: "",
      fileListShow: true,
      fileNum: 3,
      canSubmit: true,
    };
  },
  created() {
    if (!this.mxParams?.taskId) {
      this.mxParams = JSON.parse(localStorage.getItem("params"));
      localStorage.removeItem("params");
    }
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }

    Promise.all([
      this.getLinkTaskData(),
      this.getAssessTypeData(),
      this.getData(),
    ]).then(() => {
      this.handleChangeTask(this.xgpg.applyData2.v7);
    });
  },
  methods: {
    getData() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("xgpg/fetchApplyData2Action", {
            taskId: this.mxParams.taskId,
          })
          .then((res) => {
            if (res.code == 0) {
              this.fileNum = res.data.files ? 3 - res.data.files.length : 3;
              this.mxParams.status = res.data.status;
              this.mxParams.isExecutor = res.data.isExecutor;
              this.setValue(this.mxParams);
            }
            resolve();
          });
      });
    },
    getLinkTaskData() {
      return new Promise((resolve, reject) => {
        getLinkTask({ taskId: this.mxParams.taskId, type: 1 }).then((res) => {
          if (res.code == 0) {
            this.linkList = res.data;
            resolve();
          }
        });
      });
    },

    getAssessTypeData() {
      return new Promise((resolve, reject) => {
        getDict("assess_type", 1).then((res) => {
          if (res.code == 0) {
            this.pglxList = res.data;
            resolve();
          }
        });
      });
    },
    handleChangeTask(e) {
      for (let i of this.linkList) {
        if (i.task_id == e) {
          this.xgpg.applyData2.type = i.type;
          break;
        }
      }
      this.$forceUpdate();
    },

    handleChange(file, fileList) {
      //验证上传文件的格式
      const suffixReg = /(pdf|ppt|pptx|docx|doc|zip|rar)$/;
      const point = file.name.lastIndexOf(".");
      const suffix = file.name.substr(point + 1);
      const isFile = suffixReg.test(suffix);

      for (let i in fileList) {
        if (i == fileList.length - 1) {
          continue;
        }
        if (fileList[i].name == file.name && fileList[i].size == file.size) {
          fileList.pop();
          this.$message.error("请勿上传相同文件!");
          return;
        }
      }

      if (this.xgpg.applyData2.files) {
        for (let i in this.xgpg.applyData2.files) {
          if (
            this.xgpg.applyData2.files[i].fileName == file.name &&
            this.xgpg.applyData2.files[i].fileSize == file.size
          ) {
            console.log(this.xgpg.applyData2.files[i]);

            fileList.pop();
            this.$message.error(" 请勿上传相同文件!");
            return;
          }
        }
      }
      if (!isFile) {
        this.$message.error("请上传正确格式的文件 !");
        fileList.pop();
        return false;
      }
      // 验证文件大小
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        fileList.pop();
        return false;
      }
    },
    handleExceed(file, fileList) {
      const filesLen = this.xgpg.applyData2.files
        ? this.xgpg.applyData2.files.length
        : 0;
      this.$message.error(
        `当前限制选择 3 个文件，本次选择了 ${
          fileList.length
        } 个文件，共选择了 ${filesLen + fileList.length} 个文件`
      );
    },
    handleShowAdvice(e) {
      // this.status = e;

      if (e != 1) {
        if (!this.xgpg.applyData2.v1) {
          this.$message.error("请输入评估主题！");
          return;
        }
        if (!this.xgpg.applyData2.v2) {
          this.$message.error("请列明关键问题、痛点问题和原因！");
          return;
        }
        if (!this.xgpg.applyData2.v3) {
          this.$message.error("请列明解决方案的亮点和价值！");
          return;
        }
        if (!this.xgpg.applyData2.v4) {
          this.$message.error("请输入解决一把手关注点和如何支持其实现！");
          return;
        }
        if (!this.xgpg.applyData2.v5) {
          this.$message.error("请输入报告结构！");
          return;
        }
      }
      if (!this.xgpg.applyData2.v6) {
        this.$message.error("请选择评估类型！");
        return;
      }
      const {
        process,
        id,
        linkTaskId,
        status,
        applyCount,
        v3,
        v5,
        v1,
        v2,
        v4,
        v6,
        fileId,
        jdId,
        jdName,
      } = this.xgpg.applyData2;
      let data = {
        taskId: this.mxParams.taskId,
        id,
        linkTaskId,
        status,
        process,
        applyCount,
        v3,
        v5,
        v1,
        v2,
        v4,
        v6,
        fileId,
        jdId,
        jdName,
      };
      this.$refs["applyForm"].validate((valid) => {
        if (valid) {
          let { uploadFiles } = this.$refs.upload;
          let fileLen = uploadFiles.length;
          let form = new FormData();
          uploadFiles.forEach((item, index) => {
            form.append("files", item.raw);
          });
          if (this.canSubmit) {
            this.canSubmit = false;
            Loading.service({ body: true });
            if (fileLen > 0) {
              //上传文件
              form.append("taskId", this.mxParams.taskId);
              return new Promise((resolve, reject) => {
                uploadFile(form)
                  .then((res) => {
                    if (res.code == 0) {
                      this.$message.success("上传成功！");
                      if (data.fileId) {
                        data.fileId += "," + res.data;
                      } else {
                        data.fileId = res.data;
                      }
                      if (e == 1) {
                        this.handleSave(data);
                      } else {
                        this.handleSubmit(data);
                      }
                    } else {
                      this.canSubmit = true;
                      this.closeLoading();
                      this.$message({
                        type: "error",
                        message: res.msg,
                        showClose: true,
                      });
                    }
                    resolve(res);
                  })
                  .catch((err) => {
                    reject(err);
                  });
              });
            } else {
              if (this.xgpg.applyData2.fileId) {
                if (e == 1) {
                  this.handleSave(data);
                } else {
                  this.handleSubmit(data);
                }
              } else {
                this.canSubmit = true;
                this.closeLoading();
                this.$message.error("请上传文件！");
                return false;
              }
            }
          }
        } else {
          this.$message.error("请输入表单必填字段！");
        }
      });
    },
    handleSave(data) {
      saveZxpsApply(data).then((res) => {
        if (res.code == 0) {
          this.canSubmit = true;
          this.closeLoading();
          this.$message.success(res.msg);
          this.$emit("giveFather", false);
        }
      });
    },
    handleSubmit(data) {
      submitZxpsApply(data).then((res) => {
        if (res.code == 0) {
          this.canSubmit = true;
          this.closeLoading();
          this.$message.success(res.msg);
          this.$emit("giveFather", false);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleShowHistory() {
      this.historyDialog = true;
      const data = {
        taskId: this.mxParams.taskId,
        linkPoint: this.mxParams.linkPoint,
        page: 1,
        pageSize: 100,
      };
      getZxpsGw({ taskId: this.mxParams.taskId }).then((res) => {
        if (res.code == 0) {
          this.historyList = res.data.zxpsGw;
          this.title = res.data.title;
        }
      });
    },
    giveFather() {
      this.parentDialog = false;
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    handleDeleteFile(row) {
      const fileId = "" + row.fileId;
      delFileInfo({
        fileId,
        absolutePath: row.absolutePath,
        id: this.xgpg.applyData2.id,
      }).then((res) => {
        if (res.code === 0) {
          this.$message.success("删除成功！");
          const tempFileList = [];
          for (let i of this.xgpg.applyData2.files) {
            if (i.fileId == fileId) {
              continue;
            } else {
              tempFileList.push(i);
            }
          }
          this.xgpg.applyData2.files = tempFileList;
          this.xgpg.applyData2.fileId = this.xgpg.applyData2.fileId.split(",");
          this.xgpg.applyData2.fileId = this.xgpg.applyData2.fileId.filter(
            (item) => item !== null && item !== undefined && item !== ""
          );
          const tempFileIdArr = [];
          for (let i of this.xgpg.applyData2.fileId) {
            if (i == fileId) {
              continue;
            } else {
              tempFileIdArr.push(i);
            }
          }
          this.xgpg.applyData2.fileId = tempFileIdArr.join(",");
          this.fileNum = this.fileNum + 1;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    setValue() {
      this.$emit("getValue", this.mxParams); //触发transfer方法，this.value为向父组件传递的数据
    },
    handleDownloadFile(row) {
      const filePath = row.absolutePath;
      const fileName = row.fileName;
      let url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;

      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    handleViewFile(row) {
      const url = row.serverPath;
      window.open(url);
    },
    closeLoading() {
      let loadingInstance = Loading.service({ body: true });
      this.$nextTick(() => {
        // 以服务的方式调用的 Loading 需要异步关闭
        loadingInstance.close();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 55px;
}

.table {
  .table-header {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #f2f2f2;
    display: flex;
    justify-content: center;
    > div {
      width: 20%;
      display: flex;
      justify-content: center;
      > div {
        color: #036eb8;
        padding: 0 10px;
        font-size: 25px;
        cursor: pointer;
      }
    }
    > div:nth-of-type(2) {
      width: 40%;
    }
  }
  .table-none {
    text-align: center;
    color: #999;
    margin: 10px 0;
  }
  .table-body {
    .table-tr {
      display: flex;
      height: 44px;
      line-height: 44px;
      text-align: center;
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #f2f2f2;
      // border-left: 1px solid #f2f2f2;
      .table-td {
        display: flex;
        justify-content: center;
        width: 20%;
        // border-right: 1px solid #f2f2f2;
      }
      .table-td:nth-of-type(2) {
        width: 40%;
      }
      .del {
        color: #ff0000;
        cursor: pointer;
      }
    }
  }
}
.scroll_row {
  max-height: 500px;
  overflow: auto;
  width: calc(100% + 20px);
  padding: 15px 20px 0 0;
  border-top: 1px solid #dcdfe6;
  // display: flex;

  .row_title {
    display: flex;
    justify-content: space-between;
    line-height: 44px;
    div:nth-of-type(1) {
      text-align: right;
    }
    div:nth-of-type(2) {
      color: #036eb8;
      cursor: pointer;
    }
    span {
      color: #f56c6c;
    }
  }
}
.history_row {
  display: flex;
  div {
    margin-right: 30px;
    line-height: 44px;
  }
}
.advice_row {
  display: flex;
  width: 100%;
  margin-bottom: 15px;
  > div:nth-of-type(1) {
    width: 70px;
  }
  > div:nth-of-type(2) {
    width: calc(100% - 70px);
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

::v-deep.xgpg_audit_form .el-form-item {
  margin-bottom: 0;
}
</style>